import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import {
  prefixCurriculumName,
  setSubChildId,
} from "Login/routes/Administrator/modules/AdministratorModule";
import SubjectsGroupByTerms from "Administrator/routes/DPAcademicSetup/routes/AssessmentCategories/routes/SubjectsGroupByTerms";
export default store => ({
  path: "assessment-setup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    const state = store.getState();
    const curriculumProgramId = _.get(
      state,
      "platform.currentCurriculumProgram.id"
    );
    const childId = store.dispatch(
      prefixCurriculumName({
        childId: "ASSESSMENTS_SETUP",
        curriculumProgramId,
      })
    );
    store.dispatch(setSubChildId(childId));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
  childRoutes: [SubjectsGroupByTerms(store)],
});
